namespace RioERP.Carts {
    export namespace CounterCartService {
        export const baseUrl = 'Carts/CounterCart';

        export declare function Create(request: Serenity.SaveRequest<CounterCartRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<CounterCartRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function ConvertToOrder(request: Serenity.SaveRequest<CounterCartRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<CounterCartRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<CounterCartRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function RetrieveCounterCart(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<CounterCartRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Carts/CounterCart/Create",
            Update = "Carts/CounterCart/Update",
            ConvertToOrder = "Carts/CounterCart/ConvertToOrder",
            Delete = "Carts/CounterCart/Delete",
            Retrieve = "Carts/CounterCart/Retrieve",
            List = "Carts/CounterCart/List",
            RetrieveCounterCart = "Carts/CounterCart/RetrieveCounterCart"
        }

        [
            'Create', 
            'Update', 
            'ConvertToOrder', 
            'Delete', 
            'Retrieve', 
            'List', 
            'RetrieveCounterCart'
        ].forEach(x => {
            (<any>CounterCartService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
